import React, { useState, useEffect } from 'react';

/**
 * MUI Components
 */
import { Button, TextField, DialogActions, DialogContent, DialogTitle } from '@mui/material';

/**
 * Hooks
 */
import { useTranslation } from 'react-i18next';
import useToken from '../../hooks/useToken';

/**
 * Components
 */
import VehicleSelector from './VehicleSelector';
import PhotoManager from '../Reports/PhotoManager';

/**
 * Utils
 */
import { fetchVehicles } from '../../utils/api';

const SendVehicleAlertForm = ({ onClose, onSubmit }) => {
    const { t } = useTranslation();
    const [title, setTitle] = useState('');
    const [body, setBody] = useState('');
    const [vehicles, setVehicles] = useState([]);
    const [vehicle, setVehicle] = useState([]);
    const [photos, setPhotos] = useState([]);
    const [loadingVehicles, setLoadingVehicles] = useState(false);
    const { token } = useToken();

    useEffect(() => {
        const abortController = new AbortController();
        const signal = abortController.signal;

        setLoadingVehicles(true);
        try {
            fetchVehicles(token, signal).then(vehicles => {
                setVehicles(vehicles);
            });
        } catch (error) {
            console.error('Error fetching vehicles', error);
        } finally {
            setLoadingVehicles(false);
        }

        return () => abortController.abort();
    }, [token]);

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!isValid) return;

        onSubmit({
            is_pwa: true,
            cause: body,
            asset_type: 'vehicle',
            asset_ids: vehicle.map(v => v.id),
            photos,
        });
    };

    const isValid = vehicle.length > 0 && body.trim();

    return (
        <form onSubmit={handleSubmit}>
            <DialogTitle>{t('Send notification')}</DialogTitle>
            <DialogContent>
                <VehicleSelector
                    vehicles={vehicles}
                    loading={loadingVehicles}
                    value={vehicle}
                    onChange={setVehicle}
                    required
                />
                <TextField
                    label={t('Cause')}
                    fullWidth
                    margin="normal"
                    multiline
                    rows={4}
                    value={body}
                    onChange={(e) => setBody(e.target.value)}
                    required
                />
                <PhotoManager
                    photos={photos}
                    setPhotos={setPhotos}
                    enableNotes={false}
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>{t('Cancel')}</Button>
                <Button type="submit" variant="contained" disabled={!isValid}>{t('Send')}</Button>
            </DialogActions>
        </form>
    );
};

export default SendVehicleAlertForm;
